<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #displayTitle="{row}">
        <span>{{ row.title }}</span>
        <br />
        <span>{{ row.flowInstanceTitle }}</span>
      </template>

      <template v-slot:displayApplicant="{ row }">
        <span>{{ row.applicantName }}</span>
        <br />
        <span>{{ row.applyTime }}</span>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>

      <template #opt="{ row }">
        <el-tooltip
          v-if="allow('R')"
          effect="dark"
          :content="$l('table_tooltip_review') || '审核'"
          placement="top"
        >
          <i class="el-icon-thumb tool-btn" @click="$emit('review', row)" />
        </el-tooltip>
      </template>

      <template #empty>
        <div class="text-center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>

<style lang="scss" scoped></style>
